import axios from "axios";

const Url = process.env.REACT_APP_MAIN_URL;

export const GET_ADMIN_DASHBOARD_REQUEST = "GET_ADMIN_DASHBOARD_REQUEST";
export const GET_ADMIN_DASHBOARD_SUCCESS = "GET_ADMIN_DASHBOARD_SUCCESS";
export const GET_ADMIN_DASHBOARD_FAILURE = "GET_ADMIN_DASHBOARD_FAILURE";

/**
 * GET /api/admin/dashboard?sportId=…
 * sportId null → all sports.
 */
export const GetAdminDashboard = (sportId, token) => async (dispatch) => {
  dispatch({ type: GET_ADMIN_DASHBOARD_REQUEST, meta: { sportId } });
  try {
    const response = await axios.get(`${Url}api/admin/dashboard`, {
      params: sportId ? { sportId } : {},
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch({
      type: GET_ADMIN_DASHBOARD_SUCCESS,
      payload: response.data?.data ?? null,
      meta: { sportId },
    });
  } catch (error) {
    dispatch({
      type: GET_ADMIN_DASHBOARD_FAILURE,
      payload: error.response?.data?.message || error.message || "Could not load the dashboard",
      meta: { sportId },
    });
  }
};

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_DASHBOARD_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_ADMIN_DASHBOARD_SUCCESS:
      return { ...state, isLoading: false, data: action.payload, error: null };
    case GET_ADMIN_DASHBOARD_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default dashboardReducer;
